/**
 * Created by zhangrp on 2018/4/3.
 */

import { Utils } from '../../app.base';
import { MsgBox, Vue } from '../../app.vues';

import SwbVendorForComnSelect from './VendorForComnSelect';
Vue.regist(SwbVendorForComnSelect);

//选择供应商公共组件
/**
 * @param self
 * @param showContractVendor 展示合同供应商，不传默认不展示
 * @param showRelVendor 展示备选关联供应商，不传默认不展示
 * @param showOthersVendor 展示备选其他供应商，不传默认不展示
 * @param showAllVendor 展示全部供应商，不传默认展示
 * @param multiSelect 多选框，不传默认多选
 * @param filter 列表过滤条件
 * @param initCheckedItem 单选初始选择项
 * @param initCheckedItems 多选初始选择项
 * @param callback
 */
export function openVendorSelectComnDlg(self, params, callback) {
    let showContract = params.showContract || false;
    let showOrder = params.showOrder || false;
    let showAmbilateralBizRel = params.showAmbilateralBizRel || false;
    let showBizRel = params.showBizRel || false;
    let showAdverseBizRel = params.showAdverseBizRel || false;
    let showNoScoreBizRel = params.showNoScoreBizRel || false;
    let showShieldedBizRel = params.showShieldedBizRel || false;
    let showAll = params.showAll || false;
    let multiSelect = params.multiSelect == null ? true : params.multiSelect;
    let multiSelectDisabled = params.multiSelectDisabled || false;
    let filter = params.filter || {};
    let initCheckedId = params.initCheckedId || null;
    let initCheckedIds = params.initCheckedIds || [];
    let warnMessage = params.warnMessage == null ? true : params.warnMessage; // 警告提示（没有选择提示）
    if(!showContract && !showOrder && !showAmbilateralBizRel && !showBizRel && !showAdverseBizRel && !showNoScoreBizRel && !showShieldedBizRel && !showAll) {
        MsgBox.warning("至少展示一种类型的供应商!");
        return;
    }
    let theDlg = Vue.$showDialog({
        title: '供应商 - 选择',
        width: -600,
        height: '80%',
        showCloseBtn: true,
        template: '<div>' +
        '<swb-vendor-for-comn-select :showContract="showContract" :showOrder="showOrder" :showAmbilateralBizRel="showAmbilateralBizRel"' +
        ':showBizRel="showBizRel" :showAdverseBizRel="showAdverseBizRel" :showNoScoreBizRel="showNoScoreBizRel" :showShieldedBizRel="showShieldedBizRel"' +
        ':showAll="showAll" :multiSelect="multiSelect" :multiSelectDisabled="multiSelectDisabled"  :filter="filter" :initCheckedId="initCheckedId"' +
        ':initCheckedIds="initCheckedIds" :warnMessage = "warnMessage" ref="swb_vendor_for_comn_select"></swb-vendor-for-comn-select>' +
        '</div>',
        data: {
            showContract: showContract,
            showOrder: showOrder,
            showAmbilateralBizRel: showAmbilateralBizRel,
            showBizRel: showBizRel,
            showAdverseBizRel: showAdverseBizRel,
            showNoScoreBizRel: showNoScoreBizRel,
            showShieldedBizRel: showShieldedBizRel,
            showAll: showAll,
            multiSelect: multiSelect,
            multiSelectDisabled: multiSelectDisabled,
            filter: filter,
            initCheckedId: initCheckedId,
            initCheckedIds: initCheckedIds,
            warnMessage: warnMessage
        },
        okClicked: function () {
            let result = this.$refs.swb_vendor_for_comn_select.getDlgResult() || {};
            if(result.type == "info") {
                //
                let returnData = {};
                returnData.checkedIds = result.checkedIds || [];
                returnData.checkedId = result.checkedId || null;
                returnData.checkedList = result.data || [];
                callback(returnData);
                return true;
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        },
        methods: {}
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/vendor/selectDlg.js
// module id = 94
// module chunks = 0